import React from 'react';

const NotFound = () => {
    return (
        <div className="container">
            <div className='text-center mt-5 text-danger'>
                <h1>404</h1>
                <h3>The page you are looking for was not found.</h3>
            </div>
        </div>
    );
};

export default NotFound;